<template>
  <div class="display-rating">
    <div class="display-rating__label">
      {{ label }}
    </div>
    <div>
      <StIcon
        v-for="item in maxRating"
        :key="item"
        :color="item <= selectedRating ? 'var(--ds-color-chart-16)' : 'var(--ds-color-icon-2)'"
        icon-name="star"
        @click="addRating(item)"
      />
    </div>
  </div>
</template>

<script>
import { RATING_TYPE } from '@/store/modules/cards/constants';

export default {
  name: 'RatingFilter',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Avaliação',
    },
    surveyType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      maxRating: 0,
      selectedRating: 0,
    };
  },
  watch: {
    value(newValue) {
      if (newValue.length === 0) {
        this.selectedRating = 0;
      }
    },
  },
  mounted() {
    this.maxRating = RATING_TYPE[this.surveyType.toUpperCase()].maxRating;
  },
  methods: {
    addRating(item) {
      this.value.splice(0, this.value.length);
      this.selectedRating = item;

      for (let i = 0; i < item; i++) {
        this.value.push(item - i);
      }

      this.$emit('update:value', this.value);
    },
  },
};

</script>

<style scoped lang="scss">
  .display-rating {
    display: flex;
    flex-direction: column;

    &__label {
      font-size: var(--ds-font-size-xs);
      color: var(--gray-400) !important;
    }
  }
</style>
